import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const getVenueMonths = (
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/dates",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const getVenueDashboard = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dashboard",
        successMethod,
        errorMethod,
        getAccessTokenSilently
    );
};

export const findVenueSellPurchasesAll = (
    venueId,
    month,
    year,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/purchases/all/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDanceHistory = (
    venueId,
    month,
    year,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dances/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDrinkHistory = (
    venueId,
    month,
    year,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/drinks/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueTipHistory = (
    venueId,
    month,
    year,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/tips/" + month + "/" + year,
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

